import { partial } from '../../../util/translation/translation';

// The feed types an admin can add (the content service accepts these)
export const CREATABLE_PROVIDER_TYPES = [
  'rss',
  'youtube-feed',
  'ntf-rss',
  'sil-rss',
  'sportality',
];

// A public http(s) address; the content service checks it too
const isFeedUrl = (value) => {
  try {
    const url = new URL(`${value || ''}`.trim());
    return (
      ['http:', 'https:'].includes(url.protocol) && url.hostname.includes('.')
    );
  } catch {
    return false;
  }
};

const validateProvider = (values, { isCreate }) => {
  const p = partial('NewsForm');
  const errors = {};
  if (isCreate) {
    if (!values.type?.value) {
      errors.type = p('providerTypeEmpty');
    }
    if (!values.url?.trim()) {
      errors.url = p('feedUrlEmpty');
    } else if (!isFeedUrl(values.url)) {
      errors.url = p('feedUrlInvalid');
    }
  }
  return errors;
};

export default validateProvider;
